export enum IDVerificationStatus {
  NULL = "NULL",
  INPROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  FAILED = "FAILED",
  VERIFIED = "VERIFIED",
}

export type UserIDVerificationObj = {
  personaInquiryId: string;
  status: IDVerificationStatus;
};
